// Status do inventário de estoque (valores devolvidos por fv-api `inventory`).
export const INVENTORY_STATUS = {
    draft: { label: 'Rascunho', tone: undefined, bg: 'background.subtle', color: 'text.secondary' },
    counting: { label: 'Em contagem', tone: 'info', bg: 'info.bg', color: 'primary.main' },
    review: { label: 'Em conferência', tone: 'warning', bg: 'warning.bg', color: 'warning.main' },
    completed: { label: 'Concluído', tone: 'success', bg: 'success.bg', color: 'success.main' },
    canceled: { label: 'Cancelado', tone: 'danger', bg: 'error.bg', color: 'error.main' },
};

// Erros do backend de inventário vêm como texto puro (http.Error).
export function inventoryErrorMessage(error, fallback) {
    const data = error?.response?.data;
    if (typeof data === 'string' && data.trim()) return data.trim();
    if (data && typeof data.error === 'string') return data.error;
    return fallback;
}
